import React from 'react';
import TemplateImage from './TemplateImage';
import findSize from '../../utils/findSize';
import { Sizes } from '../../utils/types';

// a height or width should be specified for each image
// and corresponding maximum for rows and columns where possible

type VideoLayoutProps = {
  sizes: Sizes;
};

export default function VideoLayout({ sizes }: VideoLayoutProps) {
  return (
    <div className="select-none overflow-hidden p-8">
      <div className="mx-auto flex w-full max-w-[675px] flex-col items-end gap-4 overflow-hidden">
        <div className="flex w-full flex-row justify-center gap-4">
          <TemplateImage size={findSize(sizes, 1920, 1080)} height={122} />
          <TemplateImage size={findSize(sizes, 1200, 1200)} height={122} />
        </div>
        <div className="flex flex-row items-start gap-4">
          <TemplateImage size={findSize(sizes, 463, 1250)} height={268} top />
          <div className="flex max-h-[268px] max-w-[410px] flex-col items-start gap-4">
            <div className="flex max-h-[142px] max-w-[410px] flex-row items-start gap-4">
              <TemplateImage size={findSize(sizes, 1920, 1080)} width={253} top />
              <TemplateImage size={findSize(sizes, 1080, 1080)} width={142} top />
            </div>
            <TemplateImage size={findSize(sizes, 1280, 720)} height={112} top />
          </div>
        </div>
      </div>
    </div>
  );
}
